// extracted by mini-css-extract-plugin
export var center = "_5m-2";
export var clickableRow = "_5m-5";
export var expandedRow = "_5m-7";
export var hoverable = "_5m-4";
export var left = "_5m-1";
export var right = "_5m-3";
export var row = "_5m-0";
export var selectedRow = "_5m-6";
export var summaryRow = "_5m-8";